import { Tooltip, TooltipContent, TooltipTrigger, cn } from "ui";

interface TruncatedTooltipProps {
  text: string;
  className?: string;
  isDisabled?: () => boolean;
}

export function TruncatedTooltip(props: TruncatedTooltipProps) {
  return (
    <Tooltip delayDuration={1000}>
      <TooltipTrigger
        asChild
        onPointerMove={function (event) {
          if (props.isDisabled?.()) {
            event.preventDefault();
          }
        }}
      >
        <span className={cn("truncate", props.className)}>{props.text}</span>
      </TooltipTrigger>
      <TooltipContent>{props.text}</TooltipContent>
    </Tooltip>
  );
}
